<template>
    <div>
        <el-row v-if="chain_done" style="padding-top:40px;">
            <el-col :span="4" style="text-align:center;">
                <h4>Done</h4>
            </el-col>
            <el-col :span="10" style="text-align:center;">
                <el-button @click="go_assets()">Import more assets</el-button>
            </el-col>
            <el-col :span="10" style="text-align:center;">
                <el-button @click="go_rules()">Manage rules</el-button>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        props: ['job_chain_id','extent_id','chain_done'],
        mounted() {
        },
        data() {
            return {
                ruleset_id: null
            }
        },
        methods: {
            go_assets() {
                window.location.href = "/dataImports/create"
            },
            go_rules() {
                axios.get('/api/jobChains/ruleset_id/' + this.job_chain_id)
                    .then(response => {
                        this.ruleset_id = response.data
                        console.log('this is the ruleset_id we got back from the /api/jobChains/ruleset_id route')
                        console.log(this.ruleset_id)
                        var next_url = "/rules/" + this.ruleset_id
                        console.log('next url:')
                        console.log(next_url)
                        window.location.href = next_url
                    })
                    .catch(error => {
                        console.log('oops getting ruleset id')
                    })
            }
        }
    }
</script>